import React from 'react';
import '../App.css';

class GameGalleryItem extends React.PureComponent
{
	itemClicked = (index) =>
	{
		console.log("Clicked! " + index);

		this.props.setCurrentGameIndex.call(this, index);
		window.AdjustGameGallery(index);
	}

	render()
	{
		var data = this.props.data;

		return (

			<div
				className='games-gallery-item'
				onClick={this.itemClicked.bind(this, this.props.index)}
			>
				<img
					className='game-gallery-item-img'
					src={require("../images/game_banners/" + data.gameBannerURL)}
				/>
				
			</div>

		);
	}
}

export default GameGalleryItem;